import React, { useEffect, useState } from "react";
import SingleProduct from "../../../shared-components/SingleProduct/SingleProduct";
import SingleProductFixed from "../../../shared-components/SingleProductFixed/SingleProductFixed";
import SingleCollection from "../../../shared-components/SingleCollection/SingleCollection";
// import Wallet from "../../../shared-components/Wallet/Wallet";
import { AnimationFileLoader } from "../../../utilis/animation-loader"; // Adjust the path
import { fetchFixedListings, fetchAuctions, cancelAuction, bidAuction } from "../../../utilis/web3";
// Import Swiper React components
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Link, NavLink } from "react-router-dom";
import { useAccount } from "wagmi";
//Particle Js
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

function HomeV1() {
  AnimationFileLoader();

  const [fixedListing, setFixedListing] = useState();
  const [auctionListing, setAuctionListing] = useState();
  const [auctionPrice, setAuctionPrice] = useState(0);
  const { address, isConnected } = useAccount();

  const handleAuctionPriceChange = (event) => {
    setAuctionPrice(event.target.value);
  };

  const changeFixedListing = (tokenIdToRemove) => {
    setFixedListing((prevListing) => {
      const updatedListing = { ...prevListing };
      delete updatedListing[tokenIdToRemove];
      return updatedListing;
    });
  };

  const changeAuctionListing = (tokenIdToRemove) => {
    setAuctionListing((prevListing) => {
      const updatedListing = { ...prevListing };
      delete updatedListing[tokenIdToRemove];
      return updatedListing;
    });
  };

  const handlePlaceBid = async (tokenId, auctionPrice, currentPrice) => {
    const placeBid = await bidAuction(address, tokenId, auctionPrice, currentPrice)
    if (placeBid) {
      await fetchData()
    }
  }

  const handleCancelAuction = async (tokenId) => {
    const auctionCancelled = await cancelAuction(address, tokenId)
    if (!auctionCancelled) {
      setAuctionListing((prevAuctionListing) => {
        const updatedAuctionListing = { ...prevAuctionListing };
        delete updatedAuctionListing[tokenId];
        return updatedAuctionListing;
      });

    }
  };

  const fetchData = async () => {
    const data = await fetchFixedListings();
    const auctionData = await fetchAuctions()
    if (data) {
      setFixedListing(data);
    }

    if (auctionData) {
      // console.log("auctionData", auctionData)
      setAuctionListing(auctionData)
    }
  }

  useEffect(() => {

    fetchData();

  }, [address]);

  const particlesInit = async (main) => {
    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(main);
  };
  const particlesLoaded = (container) => { };

  return (
    <>
      {/* Banner  */}

      <div className="banner ov-hidden" data-bg-img="/img/bg/banner-bg.png">
        <Particles
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            fullScreen: false,
            fpsLimit: 60,
            particles: {
              number: {
                value: 200,
                density: {
                  enable: true,
                  value_area: 800,
                },
              },
              color: {
                value: "#ffffff",
              },
              shape: {
                type: "circle",
                stroke: {
                  width: 0,
                  color: "#000000",
                },
                polygon: {
                  nb_sides: 5,
                },
                image: {
                  src: "/img/github.svg",
                  width: 100,
                  height: 100,
                },
              },
              opacity: {
                value: 0.5,
                random: false,
                anim: {
                  enable: false,
                  speed: 1,
                  opacity_min: 0.1,
                  sync: false,
                },
              },
              size: {
                value: 3,
                random: true,
                anim: {
                  enable: false,
                  speed: 40,
                  size_min: 0.1,
                  sync: false,
                },
              },
              line_linked: {
                enable: false,
                distance: 150,
                color: "#ffffff",
                opacity: 0.4,
                width: 1,
              },
              move: {
                enable: true,
                speed: 2,
                direction: "none",
                random: false,
                straight: false,
                out_mode: "out",
                bounce: false,
                attract: {
                  enable: false,
                  rotateX: 600,
                  rotateY: 1200,
                },
              },
              interactivity: {
                detect_on: "canvas",
                events: {
                  onhover: {
                    enable: false,
                    mode: "repulse",
                  },
                  onclick: {
                    enable: true,
                    mode: "push",
                  },
                  resize: false,
                },
                modes: {
                  grab: {
                    distance: 400,
                    line_linked: {
                      opacity: 1,
                    },
                  },
                  bubble: {
                    distance: 400,
                    size: 40,
                    duration: 2,
                    opacity: 8,
                    speed: 3,
                  },
                  repulse: {
                    distance: 200,
                    duration: 0.4,
                  },
                  push: {
                    particles_nb: 4,
                  },
                  remove: {
                    particles_nb: 2,
                  },
                },
              },
              retina_detect: true,
            },
          }}
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              {/* Banner Content  */}
              <div className="banner-content text-white mt-xl-5 pt-xl-2 mb-5 mb-lg-0">
                <h1>
                  Digital Collection & Sell on <span>NFTs</span> Marketplace
                </h1>
                <ul className="list-info text-white">
                  <li>
                    <h4>
                      <span className="counter">3</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Artwork</h6>
                  </li>
                  <li>
                    <h4>
                      <span className="counter">9</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Auction</h6>
                  </li>
                  <li>
                    <h4>
                      <span className="counter">6</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Artist</h6>
                  </li>
                </ul>
                <div className="button-group">
                  <Link to="/explore/explore" className="btn">
                    <img src="/img/icons/discover.svg" alt="" className="svg" />
                    Discover
                  </Link>
                  {isConnected ? (
                    <Link to="/explore/create/upload" className="btn btn-link">
                      <img
                        src="/img/icons/create-icon.svg"
                        alt=""
                        className="svg"
                      />
                      Create NFT
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* End Banner Content  */}
            </div>
            <div className="col-lg-6">
              {/* Banner IMG  */}
              {auctionListing ? (
                Object.keys(auctionListing).map((tokenId, index) => {
                  if (index === 0) {
                    const nft = auctionListing[tokenId];
                    return (
                      <div key={tokenId} className="banner-img mb-60 mb-lg-0">
                        <img src={nft?.image} alt={nft?.name} style={{ maxHeight: "800px" }} />

                        <div className="banner-img-content">
                          <h2>{nft?.name}</h2>
                          <p className="me-auto hours text-white style--two">Seller: {nft?.seller?.slice(0, 5)}...{nft?.seller?.slice(-4)}</p>
                          <p className="me-auto hours text-white style--two">Highest Bidder: {nft?.highestBidder?.slice(0, 5)}...{nft?.highestBidder?.slice(-4)}</p>
                          <p className="me-auto hours text-white style--two">Starting Price: {nft?.startingPrice} ETH</p>
                          <ul className="list-info text-white style--two">
                            <li>
                              <h5>Current Bid</h5>
                              <h4 className="mb-0">
                                <img src="/img/icons/eth.svg" alt="" className="svg" />{" "}
                                {nft?.currentPrice} ETH
                              </h4>
                            </li>
                            <li>
                              <h5>Auction Ending On</h5>
                              <div className="countdown-wrap">
                                <img src="/img/icons/time.svg" alt="" className="svg" />
                                <ul className="countdown">
                                  <li>
                                    <span className="hours">{nft?.endTime.split(",")[0]}</span>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>

                          <div className="button-group">

                            <div className="d-flex flex-column text-center justify-content-between align-items-center">

                              {nft?.seller !== address && nft?.highestBidder !== address ? (
                                <>
                                  <p className="me-auto hours text-white style--two">Bid Price in ETH:</p>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="bidPrice"
                                    min={parseInt(nft?.currentPrice) + 0.01}
                                    step="0.01"
                                    onChange={handleAuctionPriceChange}
                                    placeholder={parseInt(nft?.currentPrice) + 0.01}
                                    required
                                  />
                                </>
                              ) : null}

                              <button to="/pages/item-details" disabled={nft?.highestBidder === address && nft?.seller !== address}
                                onClick={() => (nft?.seller === address ? handleCancelAuction(tokenId) : handlePlaceBid(tokenId, auctionPrice, nft?.currentPrice))}
                                className="btn btn-sm">
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                {nft?.seller === address ?
                                  "Cancel Auction" : "Place Bid"
                                }
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                  return null; // Skip rendering for other items
                })
              ) : ""}

            </div>
          </div>
        </div>
      </div>
      {/* End Banner  */}

      {/* About  */}
      {/* <section className="pt-120 pb-120"> */}
      {/* <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="section-title text-white mb-4">
                <h2>Who Trust In Us</h2>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="content text-white mt-n1">
                <p>
                  NFTs are non-fungible tokens. They are unique items that you
                  can't replace with something else. For example, NavLink
                  one-of-NavLink-kind trading card is an NFT – you can't just
                  replace it with any other card. If you trade your card for
                  some other card, you have something different. These differ
                  from fungible items, which are often the same as each other.
                </p>
                <p>
                  Example, NavLink one-of-NavLink-kind trading card is an NFT –
                  you can't just replace it with any other card. If you These
                  differ from fungible items, which are often the same as each
                  other
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-5 pt-1">
            <div className="col-12">
              {/* Swiper  */}

      {/* <Swiper
                modules={[Autoplay]}
                className="swiper walletCarousel"
                loop={true}
                navigation={true}
                spaceBetween={30}
                slidesPerView="auto"
                autoplay={true}
              >
                <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet1.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet2.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet3.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet4.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet5.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet6.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* In order to make the infine loop working we have to add double the amount of slides  get the slideperview from swiper hook => params => slidesPerView */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet1.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet2.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet3.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet4.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet5.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/* <SwiperSlide> */}
      {/* <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet6.png"
                  ></Wallet> */}
      {/* </SwiperSlide> */}

      {/*  */}
      {/* </Swiper> */}
      {/* </div>
          </div>
        </div> 
      </section> */}
      {/* End About  */}

      {/* Video  */}
      {/* <div className="vdo_sec">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="vdo-btn-wrapper gradient-box">
                <img
                  src="/img/icons/bg-play.png"
                  className="gradient-box-icon"
                  alt=""
                />
                <NavLink
                  to="https://www.youtube.com/watch?v=gfGuPd1CELo"
                  className="vdo_btn popup-video icon-mobile-white"
                >
                  <img src="/img/icons/play.svg" alt="" className="svg" />
                  <h3 className="text-white">Learn How Anefty Working!</h3>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* End Video  */}

      {/* Live Sales  */}
      <section className="pt-120 mt-5 pb-120 section-shape">
        <div className="container mt-60 mt-lg-0">
          {fixedListing && Object.keys(fixedListing).length > 0 ? (
            <>
              <div className="row justify-content-center">
                <div className="col-lg-7">
                  {/* Section Title  */}
                  <div className="section-title text-white text-center">
                    <h2>Live Sales</h2>
                    <p>
                      NFTs, or non-fungible tokens, represent distinct digital
                      assets characterized by their uniqueness, rendering them
                      irreplaceable with alternative items.
                    </p>
                  </div>
                  {/* End Section Title  */}
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {/* Swiper  */}

                  <Swiper
                    className="swiper live-auction"
                    loop={true}
                    pagination={{
                      clickable: true,
                    }}
                    navigation={true}
                    autoplay={true}
                    modules={[Autoplay]}
                    spaceBetween={30}
                    slidesPerView={3}
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      768: { slidesPerView: 2 },
                      1200: { slidesPerView: 3 },
                    }}
                  >
                    {Object.keys(fixedListing).map((tokenId, index) => {
                      const nft = fixedListing[tokenId];
                      return (
                        <SwiperSlide key={index}>
                          <SingleProductFixed
                            classList="single-product style--one"
                            productPrice={nft?.price}
                            address={address}
                            tokenId={tokenId}
                            imgSrc={nft?.image}
                            supply={nft?.supply}
                            blockchain={nft?.blockchain}
                            name={nft?.name}
                            changeFixedListing={changeFixedListing}
                            collection={nft?.collection}
                            description={nft?.description}
                            listed={nft?.listed}
                            seller={nft?.seller}
                          />
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                  {/*  */}
                </div>
              </div>
            </>
          ) : (
            <div className="row justify-content-center">
              <div className="col-lg-7 text-center">
                {/* Section Title  */}
                <div className="section-title text-white text-center">
                  <h2>No Live Sales Yet</h2>
                  <p>Please try again later or mint and list your own NFT.</p>
                </div>
                <Link
                  type="button"
                  to="/explore/wallet"
                  className="btn btn-primary mx-auto"
                >
                  Wallet
                </Link>
                {/* End Section Title  */}
              </div>
            </div>
          )}
        </div>
      </section>
      {/* End Live Auction  */}

      {/* Live Auction  */}
      <section className="pt-120 mt-5 pb-120 section-shape">
        <div className="container mt-60 mt-lg-0">
          {auctionListing && Object.keys(auctionListing).length > 0 ? (
            <>
              <div className="row justify-content-center">
                <div className="col-lg-7">

                  <div className="section-title text-white text-center">
                    <h2>Live Auctions</h2>
                    <p>
                      NFTs are non-fungible tokens. They are unique items that you
                      can't replace with something else. for trading card is an NFT
                      – you can't just replace it with any other card.
                    </p>
                  </div>

                </div>
              </div>
              <div className="row">
                <div className="col-12">

                  <Swiper
                    className="swiper live-auction"
                    loop={true}
                    pagination={{
                      clickable: true,
                    }}
                    navigation={true}
                    autoplay={true}
                    modules={[Autoplay]}
                    spaceBetween={30}
                    slidesPerView={3}
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      768: { slidesPerView: 2 },
                      1200: { slidesPerView: 3 },
                    }}
                  >{
                      auctionListing ? (
                        Object.keys(auctionListing).map((tokenId, index) => {
                          const nft = auctionListing[tokenId];
                          return (
                            <SwiperSlide>
                              <SingleProduct
                                classList="single-product style--one"
                                currentBid={nft?.currentPrice}
                                address={address}
                                tokenId={tokenId}
                                highestBidder={nft?.highestBidder}
                                imgSrc={nft?.image}
                                endTime={nft?.endTime?.split(",")[0]}
                                supply={nft?.supply}
                                blockchain={nft?.blockchain}
                                name={nft?.name}
                                handlePlaceBid={handlePlaceBid}
                                handleCancelAuction={handleCancelAuction}
                                collection={nft?.collection}
                                description={nft?.description}
                                seller={nft?.seller}
                              />
                            </SwiperSlide>
                          );
                        })
                      ) : ""}
                  </Swiper>
                </div>
              </div>
            </>
          ) : (
            <div className="row justify-content-center">
              <div className="col-lg-7 text-center">
                {/* Section Title  */}
                <div className="section-title text-white text-center">
                  <h2>No Live Auctions Yet</h2>
                  <p>Please try again later or mint and auction out your own NFT.</p>
                </div>
                <Link
                  type="button"
                  to="/explore/wallet"
                  className="btn btn-primary mx-auto"
                >
                  Wallet
                </Link>
                {/* End Section Title  */}
              </div>
            </div>
          )}
        </div>
      </section>
      {/* End Live Auction  */}

      {/* Explore Feeds  */}
      {/* <section className="pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="section-title text-white text-center">
                <h2>Explore Feeds</h2>
                <p>
                  NFTs are non-fungible tokens. They are unique items that you
                  can't replace with something else. for trading card is an NFT
                  – you can't just replace it with any other card.
                </p>
              </div>
            </div>
          </div>
        </div>


        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          className="swiper explore-feeds"
          loop={true}
          navigation={true}
          spaceBetween={30}
          slidesPerView="auto"
          pagination={{ clickable: true }}
          autoplay={true}
        >
          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Colorful Abstract Painting"
              productPrice="0.69  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Liquid Forest Princess"
              productPrice="0.89  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="1.89  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="3.99  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="1.79  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Colorful Abstract Painting"
              productPrice="0.69  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Liquid Forest Princess"
              productPrice="0.89  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="1.89  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="3.99  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="1.79  ETH"
              info="2 to 100"
            />
          </SwiperSlide>
        </Swiper>
      </section> */}
      {/* End Explore Feeds  */}

      {/* Support Center  */}
      {/* <section className="pb-120 mt-lg-120 pt-60 pt-lg-0 section-shape section-shape-right">
        <div className="container">
          <div className="row gutter-60">
            <div className="col-lg-4">
              <div className="support-img">
                <img src="/img/media/support-img.png" alt="" />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="d-flex justify-content-end mb-60">
                <div className="quick-contact gradient-box">
                  <img
                    src="/img/icons/phone.png"
                    className="gradient-box-icon"
                    alt=""
                  />
                  <h3 className="text-white">Quick Contact Us:</h3>
                  <NavLink to="tel:0032525700">+003 252-5700</NavLink>
                </div>
              </div>

              <div className="support-content">
                <div className="section-title text-white">
                  <h2>Support Center</h2>
                  <p>
                    Anefty are non-fungible tokens. they are unique items that
                    you can't replace with something else. for example, NavLink
                    one of NavLink kind trading card is an NFT – you can't just
                    replace it with any other card.
                  </p>
                </div>

                <form action="#" className="support-form row">
                  <div className="col-lg-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="col-lg-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                  <div className="col-12">
                    <textarea
                      name="message"
                      className="form-control"
                      placeholder="Write Message Here"
                      required
                    ></textarea>
                    <button type="submit" className="btn">
                      <img src="/img/icons/mail.svg" alt="" className="svg" />{" "}
                      Send Request
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* End Support Center  */}

      {/* Top Collection  */}
      {/* <section className=" pb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="section-title text-white text-center">
                <h2>Top Collections</h2>
                <p>
                  NFTs are non-fungible tokens. They are unique items that you
                  can't replace with something else. for trading card is an NFT
                  – you can't just replace it with any other card.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Meka_Verse"
                price="$203,621,269"
                count="01"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Bored_YachtClub"
                price="$118,321,276"
                count="02"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Bambooz_lers"
                price="$10,429,103"
                count="03"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="The_Humanoids"
                price="$7,991,156"
                count="04"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Stacked_Toadz"
                price="$6,700,653"
                count="05"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Mutant_Cats"
                price="$22,278,069"
                count="06"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Mutant_YachtClub"
                price="$10,307,676"
                count="07"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Optics_PeopleS"
                price="$19,359,169"
                count="08"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Goofy_Oversized"
                price="$203,621,269"
                count="09"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Cyber_Kongz"
                price="$7,227,956"
                count="10"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="The_DogePound"
                price="$6,609,169"
                count="11"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Halloween_Bears"
                price="$4,673,966"
                count="12"
              />
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default HomeV1;
